<style src="./Breadcrumb.scss" lang="scss" scoped></style>
<template>
  <div class="breadcrumb">
    <ul>
      <li class="icon-home">
        <router-link to="/">
          <icon-home />
        </router-link>
      </li>
      <li
        v-for="(breadcrumb, idx) in breadcrumbList"
        :key="idx"
        @click="routeTo(idx)"
        :class="{'linked': !!breadcrumb.link}">
        
        <span v-if="breadcrumb.name">{{ breadcrumb.name }}</span>
        
        <span class="eventcode" v-if="breadcrumb.eventCode">{{ breadcrumb.eventCode }}</span>
        <span class="isopenclose" v-if="breadcrumb.isOpenClose" title="Evento marcado como Aberto/Fechado">A/F</span>
        <span class="eventidentification" v-if="breadcrumb.eventIdentification">{{ breadcrumb.eventIdentification }}</span>
        <span class="clientname" v-if="breadcrumb.clientName">{{ breadcrumb.clientName }}</span>
      </li>

      <slot></slot>
    </ul>
  </div>
</template>

<script>
import { IconHome } from '@/components/primitives/icons'

export default {
  name: 'Breadcrumb',
  components: {
    IconHome
  },
  data () {
    return {
      breadcrumbList: []
    }
  },
  mounted () {
    const breadcrumbRaw = this.$route.meta.breadcrumb
    const breadcrumb = breadcrumbRaw.map((item) => {
      if (item.nameGetter) item.name = this.$store.getters[item.nameGetter]

      if (item.hasOwnProperty('eventCode')) item.eventCode = this.$store.getters['Events/EVENT_CODE']
      if (item.hasOwnProperty('isOpenClose')) item.isOpenClose = this.$store.getters['Events/IS_OPEN_CLOSE']
      if (item.hasOwnProperty('clientName')) item.clientName = this.$store.getters['Events/CLIENT_NAME']
      if (item.hasOwnProperty('eventIdentification')) item.eventIdentification = this.$store.getters['Events/EVENT_IDENTIFICATION']

      if (item.linkGetter) item.link = this.$store.getters['Events/GET_EVENT_LINK']

      return item
    })
    this.breadcrumbList = breadcrumb
  },
  methods: {
    routeTo (pRouteTo) {
      if (this.breadcrumbList[pRouteTo].link) this.$router.push(this.breadcrumbList[pRouteTo].link)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/foundation/content-header/breadcrumb/Breadcrumb.vue